export const BUSINESS_RULES_CHECKBOXES_CODES = ['checkbox1', 'checkbox2', 'checkbox3', 'checkbox4', 'checkbox5'];
